import { store } from '../store/storeMain'

export const transactionManager = {

  transactions: [],

  transactionObject: {
    id: 0,
    account: '',
    transactionName: '',
    transactionType: '',
    transactionAmount: 0,
    paymentType: '',
    budget: 'None',
    comment: '',
    category: '',
    currency: '',
    items: [],

    transactionDate: '',
    transactionTime: null,

    transferFrom: '',
    transferTo: '',

    recurringTransaction: false,

    //Recurring Transactions
    repeat: 1,
    cycle: '',
    period: 'Forever',
    numberOfCycles: 1,
    goesOffFirst: '',

    //State of Current Object
    objectState: 'New',
    show: false
  },

  getTransactions() {
    this.transactions = store.state.Transactions
  },

  addTransaction(transaction) {
    let newEntry = JSON.parse(JSON.stringify(transaction))

    this.addItem = false

    newEntry.id = this.getLargestIdFromTransactions() + 1

    this.addTransactionToStore(newEntry)

    this.adjustAccountWithTransactionAmount(transaction)
  },

  getLargestIdFromTransactions() {
    this.getTransactions()

    let largest = 0
    for (let i = 0; i < this.transactions.length; i++) {
      if (this.transactions[i].id > largest) {
        largest = this.transactions[i].id
      }
    }
    return largest
  },

  addTransactionToStore(newEntry) {
    store.commit('addNewTransactionToStore', newEntry)
  },

  adjustAccountWithTransactionAmount(currentTransaction) {
    let add = {
      account: '',
      amount: ''
    }
    let subtract = {
      account: '',
      amount: ''
    }

    if (currentTransaction.transactionType === 'income') {
      add.account = currentTransaction.account
      add.amount = currentTransaction.transactionAmount

      store.commit('addAmountToAccount', add)
    }
    else if (currentTransaction.transactionType === 'expense') {
      subtract.account = currentTransaction.account
      subtract.amount = currentTransaction.transactionAmount

      store.commit('subtractAmountFromAccount', subtract)
    }
    else if (currentTransaction.transactionType === 'transfer') {
      subtract.account = currentTransaction.transferFrom
      subtract.amount = currentTransaction.transactionAmount

      store.commit('subtractAmountFromAccount', subtract)

      add.account = currentTransaction.transferTo
      add.amount = currentTransaction.transactionAmount

      store.commit('addAmountToAccount', add)
    }
  },

  updateAccountWithChangedTransactionAmount(account, transferTo, oldAmount, newAmount, transactionType) {
    let tranObject = {
      account: '',
      amount: ''
    }

    tranObject.account = account

    if (transactionType === 'expense') {
      if (oldAmount > newAmount) {
        //Add Remainder from account
        tranObject.amount = parseFloat(oldAmount) - parseFloat(newAmount)

        store.commit('addAmountToAccount', tranObject)
      }
      else if (newAmount > oldAmount) {
        //Subtract Remainder to account
        tranObject.amount = parseFloat(newAmount) - parseFloat(oldAmount)

        store.commit('subtractAmountFromAccount', tranObject)
      }
    }
    else if (transactionType === 'income') {
      if (oldAmount > newAmount) {
        //Subtract Remainder from account
        tranObject.amount = parseFloat(oldAmount) - parseFloat(newAmount)

        store.commit('subtractAmountFromAccount', tranObject)
      }
      else if (newAmount > oldAmount) {
        //Add Remainder to account
        tranObject.amount = parseFloat(newAmount) - parseFloat(oldAmount)

        store.commit('addAmountToAccount', tranObject)
      }
    }
    else if (transferTo !== '') {
      if (oldAmount > newAmount) {
        //Subtract amount from transferTo Account
        tranObject.amount = parseFloat(oldAmount) - parseFloat(newAmount)

        store.commit('subtractAmountFromAccount', { account: transferTo, amount: tranObject.amount })

        //Add amount to transferFrom account
        store.commit('addAmountToAccount', tranObject)
      }
      else if (newAmount > oldAmount) {
        //Subtract amount from transferFrom Account
        tranObject.amount = parseFloat(newAmount) - parseFloat(oldAmount)

        store.commit('subtractAmountFromAccount', tranObject)

        //Add amount to transferTo account
        store.commit('addAmountToAccount', { account: transferTo, amount: tranObject.amount })
      }

    }

  },

  getTransactionByName(name) {
    this.getTransactions()

    for (let i = 0; i < this.transactions.length; i++) {
      if (this.transactions[i].transactionName === name) {
        return this.transactions[i]
      }
    }

  },

  updateTransaction(oldTransactionData, newTransactionData) {
    if (this.isRollbackNeeded(newTransactionData)) {
      this.updateAccountWithChangedTransactionAmount(
        newTransactionData.account,
        newTransactionData.transferTo,
        JSON.parse(JSON.stringify(oldTransactionData.transactionAmount)),
        JSON.parse(JSON.stringify(0)),
        newTransactionData.transactionType
      )
    }

    if (this.checkIfTransacationAmountNeedsAdjusting(oldTransactionData, newTransactionData)) {
      this.updateAccountWithChangedTransactionAmount(
        newTransactionData.account,
        newTransactionData.transferTo,
        JSON.parse(JSON.stringify(oldTransactionData.transactionAmount)),
        JSON.parse(JSON.stringify(newTransactionData.transactionAmount)),
        newTransactionData.transactionType
      )
    }

    let transaction = this.transferTransactionData(oldTransactionData, newTransactionData)

    this.updateTransactionInStore(transaction)

    
  },

  updateEditedTransaction(transaction) {
    let oldTransaction = this.getTransactionByName(transaction.transactionName)

    this.updateTransaction(oldTransaction, transaction)
  },

  isRollbackNeeded(transaction) {
    if (transaction.objectState === 'Delete') {
      return true
    }
    return false
  },

  checkIfTransacationAmountNeedsAdjusting(oldTransactionData, newTransactionData) {
    if (oldTransactionData.transactionAmount !== newTransactionData.transactionAmount) {
      return true
    }
    return false
  },

  updateTransactionInStore(transaction) {
    store.commit('updateTransactioninStore', transaction)
  },

  transferTransactionData(oldTransactionData, newTransactionData) {
    let transaction = this.transactionObject

    transaction.id = oldTransactionData.id
    transaction.account = newTransactionData.account
    transaction.budget = newTransactionData.budget
    transaction.category = newTransactionData.category
    transaction.comment = newTransactionData.comment
    transaction.currency = newTransactionData.currency
    transaction.cycle = newTransactionData.cycle
    transaction.goesOffFirst = newTransactionData.goesOffFirst
    transaction.items = newTransactionData.items
    transaction.numberOfCycles = newTransactionData.numberOfCycles

    if (newTransactionData.objectState === 'Delete') {
      transaction.objectState = newTransactionData.objectState
    }
    else {
      transaction.objectState = 'Update'
    }
    
    transaction.paymentType = newTransactionData.paymentType
    transaction.period = newTransactionData.period
    transaction.recurringTransaction = newTransactionData.recurringTransaction
    transaction.repeat = newTransactionData.repeat
    transaction.show = newTransactionData.show
    transaction.transactionAmount = newTransactionData.transactionAmount
    transaction.transactionDate = newTransactionData.transactionDate
    transaction.transactionName = newTransactionData.transactionName
    transaction.transactionTime = newTransactionData.transactionTime
    transaction.transactionType = newTransactionData.transactionType
    transaction.transferFrom = newTransactionData.transferFrom
    transaction.transferTo = newTransactionData.transferTo

    return transaction
  },
  




}



// WEBPACK FOOTER //
// ./src/javascript/transactionManager.js